// extracted by mini-css-extract-plugin
module.exports = {"section":"Step1_section__kehk8","image":"Step1_image__3Xchb","desc":"Step1_desc__1nPiV"};